export const environment = {
  production: false,
  apiUrl: 'https://api.keyconnect-staging.it/api/v1/',
  apiUrlWithoutProtocol: 'api.keyconnect-staging.it/api/v1/'
};
